// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forget-username-container {
  position: relative;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
}
.forget-username-container .logo {
  z-index: 1000;
  position: relative;
  padding: 0px 55px;
}
.forget-username-container .ant-row {
  justify-content: center;
}
.forget-username-container .username-forget-username {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}
.forget-username-container .forget-username-form {
  position: relative;
  background: rgba(255, 255, 255, 0.96);
}
.forget-username-container .forget-username-form .verCode-style {
  display: flex;
  align-items: flex-end;
}
.forget-username-container .forget-username-form .verCode-style .verCode-form-item {
  flex: 1;
}
.forget-username-container .forget-username-form .verCode-style .verCode-button-item {
  margin: 0 5px 25px;
}
.forget-username-container .forget-username-form .more-message {
  text-align: center;
}
.forget-username-container .forget-username-form .more-message a {
  color: #454545;
  padding: 0px 5px;
}
.forget-username-container .forget-username-form .more-message a:hover {
  color: #454545;
}
.forget-username-container .go-back-style {
  width: 100%;
}
.forget-username-container .go-back-style span {
  font-size: 14px;
}
.forget-username-container .forget-sumbit-style span {
  font-size: 14px;
}
.forget-username-container .ant-btn-round.ant-btn-lg {
  padding: 0 !important;
}
.forget-username-container .ant-btn {
  font-size: 12px !important;
}
@media (min-width: 0) and (max-width: 640px) {
  .forget-username-container .logo-box {
    padding: 0px 20px;
    margin-top: 15px;
  }
  .forget-username-container .forget-username-form {
    width: 80%;
    height: auto;
    padding: 5px 15px;
    max-width: 100%;
    margin: 0px auto 0px;
  }
}
@media (min-width: 640px) {
  .forget-username-container .logo-box {
    padding: 0px 55px;
    margin-top: 15px;
  }
  .forget-username-container .forget-username-form {
    width: 40%;
    min-width: 400px;
    margin: auto;
    padding: 10px 15px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Components/ForgetUserName/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AALA;EAMI,aAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAVA;EAWI,uBAAA;AAEJ;AAbA;EAcI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAEJ;AApBA;EAqBI,kBAAA;EACA,qCAAA;AAEJ;AAxBA;EAwBM,aAAA;EACA,qBAAA;AAGN;AA5BA;EA2BQ,OAAA;AAIR;AA/BA;EA8BQ,kBAAA;AAIR;AAlCA;EAkCM,kBAAA;AAGN;AArCA;EAoCQ,cAAA;EACA,gBAAA;AAIR;AAHQ;EACE,cAAA;AAKV;AA5CA;EA6CI,WAAA;AAEJ;AA/CA;EA+CM,eAAA;AAGN;AAlDA;EAoDM,eAAA;AACN;AArDA;EAwDI,qBAAA;AAAJ;AAxDA;EA2DI,0BAAA;AAAJ;AAIA;EACE;IAEI,iBAAA;IACA,gBAAA;EAHJ;EAAA;IAMI,UAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,oBAAA;EAHJ;AACF;AAOA;EACE;IAEI,iBAAA;IACA,gBAAA;EANJ;EAGA;IAMI,UAAA;IACA,gBAAA;IACA,YAAA;IACA,uBAAA;EANJ;AACF","sourcesContent":[".forget-username-container {\n  position: relative;\n  min-height: 100vh;\n  max-width: 100vw;\n  overflow-x: hidden;\n  .logo {\n    z-index: 1000;\n    position: relative;\n    padding: 0px 55px;\n  }\n  .ant-row {\n    justify-content: center;\n  }\n  .username-forget-username {\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n    color: #000000;\n    margin-bottom: 20px;\n  }\n  .forget-username-form {\n    position: relative;\n    background: rgba(255, 255, 255, 0.96);\n    .verCode-style {\n      display: flex;\n      align-items: flex-end;\n      .verCode-form-item {\n        flex: 1;\n      }\n      .verCode-button-item {\n        margin: 0 5px 25px;\n      }\n    }\n    .more-message {\n      text-align: center;\n      a {\n        color: #454545;\n        padding: 0px 5px;\n        &:hover {\n          color: #454545;\n        }\n      }\n    }\n  }\n  .go-back-style {\n    width: 100%;\n    span {\n      font-size: 14px;\n    }\n  }\n  .forget-sumbit-style {\n    span {\n      font-size: 14px;\n    }\n  }\n  .ant-btn-round.ant-btn-lg {\n    padding: 0 !important;\n  }\n  .ant-btn {\n    font-size: 12px !important;\n  }\n}\n\n@media (min-width: 0) and (max-width: 640px) {\n  .forget-username-container {\n    .logo-box {\n      padding: 0px 20px;\n      margin-top: 15px;\n    }\n    .forget-username-form {\n      width: 80%;\n      height: auto;\n      padding: 5px 15px;\n      max-width: 100%;\n      margin: 0px auto 0px;\n    }\n  }\n}\n\n@media (min-width: 640px) {\n  .forget-username-container {\n    .logo-box {\n      padding: 0px 55px;\n      margin-top: 15px;\n    }\n    .forget-username-form {\n      width: 40%;\n      min-width: 400px;\n      margin: auto;\n      padding: 10px 15px 10px;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
